import { Box } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import * as React from 'react';
import palette from '../palette';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    verticalAlign: 'baseline',
    display: 'inline',
    '&[disabled]': {
      color: palette.GRAPHITE,
      cursor: 'default'
    },
    paddingBottom: 3,
    '& $icon': {
      fontSize: 'inherit'
    }
  },
  button: {
    paddingBottom: 0,
    '&[disabled]': {
      color: palette.GRAPHITE,
      cursor: 'default'
    }
  },
  underline: {
    backgroundImage: `linear-gradient(transparent, transparent), linear-gradient(currentColor, currentColor) `,
    backgroundSize: '100% 2px, 0 2px',
    backgroundPosition: '100% 100%, 0 100%',
    backgroundRepeat: 'no-repeat',
    transition: '0.2s ease-out'
  },
  underlineHover: {
    '&:hover': {
      textDecoration: 'none',
      backgroundSize: '0 2px, 100% 2px',
      backgroundPosition: '0 100%, 0 100%'
    }
  },
  disableMultiline: {
    display: 'inline-flex',
    paddingBottom: 0
  },
  underlineAlways: {
    textDecoration: 'none',
    backgroundSize: '0 2px, 100% 2px',
    backgroundPosition: '0 100%, 0 100%'
  },
  icon: {
    margin: 'auto 0',
    minWidth: 20,
    minHeight: 20,
    verticalAlign: 'text-bottom'
  },
  iconLeft: {
    paddingRight: theme.spacing(0.5)
  },
  iconRight: {
    paddingLeft: theme.spacing(0.5)
  },
  iconLink: {
    paddingBottom: 2
  }
}));
const Link = ({
  children,
  disabled,
  icon,
  onClick,
  to,
  variant = 'body1',
  underline = 'hover',
  disableMultiline = false,
  type,
  iconPlacement = 'left',
  ...props
}) => {
  const classes = useStyles();
  return _jsxs(MuiLink, {
    classes: {
      root: clsx(classes.root, {
        [classes.iconLink]: !!icon,
        [classes.underline]: !disabled && underline !== 'none',
        [classes.underlineHover]: underline === 'hover',
        [classes.underlineAlways]: underline === 'always',
        [classes.disableMultiline]: disableMultiline
      }),
      button: classes.button
    },
    disabled: disabled,
    onClick: disabled ? e => e.preventDefault() : onClick,
    to: disabled ? null : to,
    variant: variant,
    underline: underline,
    ...(props.component === 'button' && {
      type: type || 'button'
    }),
    ...props,
    children: [icon && iconPlacement === 'left' && _jsx(Box, {
      component: icon,
      className: clsx(classes.icon, classes.iconLeft)
    }), children, icon && iconPlacement === 'right' && _jsx(Box, {
      component: icon,
      className: clsx(classes.icon, classes.iconRight)
    })]
  });
};
export default Link;